import { render } from "./AdCard.vue?vue&type=template&id=3bb8a32c&scoped=true"
import script from "./AdCard.vue?vue&type=script&lang=js"
export * from "./AdCard.vue?vue&type=script&lang=js"

import "./AdCard.vue?vue&type=style&index=0&id=3bb8a32c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb8a32c"]])

export default __exports__